import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表
//招募计划相关接口
;

const myAllWork = {
  //列表数据
  getPage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/partner/zmplan/page`, params);
  },
  //根据id查询单个信息
  getById(params) {
    return axios.get(`${base.bs}/admin/partner/zmplan/get/${params.id}`)
  },
  //保存修改
  saveOrUpdate(params) {
    return axios.post(`${base.bs}/admin/partner/zmplan/set`, params)
  },
  //根据id删除单个
  del(params) {
    return axios.get(`${base.bs}/admin/partner/zmplan/del/${params.id}`)
  },
  //批量删除
  batchDel(params) {
    return axios.get(`${base.bs}/admin/partner/zmplan/batchDel?ids=${params.ids}`,null)
  },
  //提交审核
  send(params) {
    return axios.get(`${base.bs}/admin/partner/zmplan/send/${params.id}`,null)
  },
  //退回
  back(params) {
    return axios.get(`${base.bs}/admin/partner/zmplan/back/${params.id}`,null)
  },
  //撤回
  chehui(params) {
    return axios.get(`${base.bs}/admin/partner/zmplan/chehui/${params.id}`,null)
  },
  //结束
  end(params) {
    return axios.get(`${base.bs}/admin/partner/zmplan/end/${params.id}`,null)
  },
  //意向演员设置
  want(params) {
    return axios.get(`${base.bs}/admin/partner/zmplan/want/${params.id}/${params.iswant}`,null)
  },

}
// 导出接口
export default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/partnerZmPlan.js